import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'NO COMPRES CUALQUIER AUTO',
  desc: 'El Sistema de Descarte Inmediato. Tu presupuesto real. La lista negra de modelos.',
  color: 'text-electric',
  bg: 'bg-electric/10',
  border: 'border-electric',
  shadow: 'shadow-[0_0_20px_rgba(217,30,24,0.5)] hover:shadow-[0_0_35px_rgba(217,30,24,0.85)]'
}, {
  num: '2',
  title: 'CÓMO ENCONTRAR UN USADO QUE VALGA LA PENA',
  desc: 'Filtros que eliminan el 80% de opciones malas. La entrevista que detecta vendedores problemáticos.',
  color: 'text-green-400',
  bg: 'bg-green-400/10',
  border: 'border-green-400',
  shadow: 'shadow-[0_0_20px_rgba(74,222,128,0.5)] hover:shadow-[0_0_35px_rgba(74,222,128,0.85)]'
}, {
  num: '3',
  title: 'LAS ESTAFAS MÁS COMUNES Y CÓMO EVITARLAS',
  desc: 'El auto mellizo. El fraude digital. Las 4 categorías de fraude del mercado.',
  color: 'text-orange-400',
  bg: 'bg-orange-400/10',
  border: 'border-orange-400',
  shadow: 'shadow-[0_0_20px_rgba(251,146,60,0.5)] hover:shadow-[0_0_35px_rgba(251,146,60,0.85)]'
}, {
  num: '4',
  title: 'QUÉ REVISAR ANTES DE PONER UN PESO',
  desc: '80 puntos de inspección en 4 fases. Cómo leer fluidos sin ser mecánico. La prueba de manejo técnica.',
  color: 'text-cyan-400',
  bg: 'bg-cyan-400/10',
  border: 'border-cyan-400',
  shadow: 'shadow-[0_0_20px_rgba(34,211,238,0.5)] hover:shadow-[0_0_35px_rgba(34,211,238,0.85)]'
}, {
  num: '5',
  title: 'CÓMO BAJAR EL PRECIO SIN PELEARTE',
  desc: 'Los 3 números que calculás antes de negociar. Las 8 objeciones del vendedor resueltas.',
  color: 'text-purple-400',
  bg: 'bg-purple-400/10',
  border: 'border-purple-400',
  shadow: 'shadow-[0_0_20px_rgba(192,132,252,0.5)] hover:shadow-[0_0_35px_rgba(192,132,252,0.85)]'
}, {
  num: '6',
  title: 'LOS PAPELES QUE TE PUEDEN SALVAR',
  desc: 'Cómo leer el informe de dominio. Prendas y embargos. La transferencia paso a paso.',
  color: 'text-gold',
  bg: 'bg-gold/10',
  border: 'border-gold',
  shadow: 'shadow-[0_0_20px_rgba(255,193,7,0.5)] hover:shadow-[0_0_35px_rgba(255,193,7,0.85)]'
}];
const inclusions = ['Contenido 100% listo — abrís el PDF y empezás', 'Protocolos de seguridad en cada procedimiento', 'Checklists, tablas de referencia y planillas', 'Diseñado para el mercado argentino'];
export function TomosSection() {
  return <section className="py-14 bg-petroleum/30 border-y border-electric/10 bg-carbon" data-id="element-519">
      <div className="container mx-auto px-4" data-id="element-520">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-521">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-red-400 to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-522"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-523">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.10] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(217,30,24,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(217,30,24,0.7) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-524"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-525"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-526"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-527"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-528"></div>

            <div className="relative z-10" data-id="element-529">
              <div className="inline-flex items-center gap-2 bg-electric text-white font-extrabold tracking-widest uppercase text-xs px-4 py-1.5 rounded-full mb-5 shadow-lg shadow-electric/40" data-id="element-530">
                <span className="w-6 h-px bg-white" data-id="element-531"></span>
                El Sistema Completo
                <span className="w-6 h-px bg-white" data-id="element-532"></span>
              </div>
              <h2 className="text-3xl md:text-5xl font-extrabold mb-4" data-id="element-533">
                🏆 PROTOCOLO AUTO USADO
              </h2>
              <div className="mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70 mb-4" data-id="element-534"></div>
              <p className="text-lg md:text-xl text-textsecondary" data-id="element-535">
                6 Tomos + 6 Bonos —{' '}
                <span className="text-white font-bold" data-id="element-536">
                  530+ páginas. Todo resuelto.
                </span>
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-537">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-petroleum rounded-2xl p-6 border-2 ${tomo.border} ${tomo.shadow} transition-all duration-300 group relative overflow-hidden hover:-translate-y-1 machined-edge`} data-id="element-538">
              <div className={`absolute top-0 right-0 w-32 h-32 ${tomo.bg} blur-3xl rounded-full -mr-10 -mt-10 transition-opacity group-hover:opacity-100 opacity-50`} data-id="element-539"></div>

              <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-540">
                <div className={`w-12 h-12 rounded-xl ${tomo.bg} ${tomo.color} flex items-center justify-center font-bold text-xl`} data-id="element-541">
                  {tomo.num}
                </div>
                <BookOpen className={`w-6 h-6 ${tomo.color} opacity-50`} data-id="element-542" />
              </div>

              <h3 className="text-lg font-bold mb-3 relative z-10" data-id="element-543">
                Tomo {tomo.num} — {tomo.title}
              </h3>
              <p className="text-textsecondary text-sm leading-relaxed relative z-10" data-id="element-544">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-graphite rounded-2xl p-8 border border-electric/20" data-id="element-545">
          <h4 className="text-center font-bold text-xl mb-6" data-id="element-546">
            Cada tomo incluye:
          </h4>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-547">
            {inclusions.map((inc, i) => <div key={i} className="flex items-start gap-3" data-id="element-548">
                <CheckCircle2 className="w-5 h-5 text-electric shrink-0 mt-0.5" data-id="element-549" />
                <span className="text-textsecondary text-sm" data-id="element-550">{inc}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}